import React, { useEffect, useRef, useState } from "react";
import styles from "./AdminSupportChat.module.scss";
import { Input, Button, Upload, message as antdMessage, Alert } from "antd";
import {
  FileOutlined,
  RollbackOutlined,
  SendOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import moment from "moment-jalaali";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCheckDouble,
  faReply,
} from "@fortawesome/free-solid-svg-icons";
import {
  getMessageListApi,
  postSupportMessageApi,
  supportStatusApi,
} from "../../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";

const AdminSupportChat = ({ info, handelCloseModal }) => {
  const [loadingState,setLoadingState]=useState(false)
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [fileList, setFileList] = useState([]);
  const [replyingTo, setReplyingTo] = useState(null); // New state to track the message being replied to
  const bottomRef = useRef(null);
  // Function to convert file to Base64
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleSendMessage = async () => {
    setLoadingState(true)
    if (inputValue.trim()) {
      const fileBase64 =
        fileList.length > 0 ? await getBase64(fileList[0].originFileObj) : null;
      let apiData = {
        id: info.id,
        message: inputValue,
        files: fileBase64 ? [fileBase64] : [],
        reply_to: replyingTo?.id || 0, // Reply to specific message if applicable
      };

      postSupportMessageApi(apiData, (succ, res) => {
        if (succ) {
          setLoadingState(false)
          if (res.status === 1) {
            getMessageListHandler();
            setInputValue(""); // Clear the input
            setFileList([]); // Clear the file list after successful send
            setReplyingTo(null); // Clear reply state after send
          } else {
            errorToast(res.message);
          }
        } else {
          console.error(res);
          setLoadingState(false)
        }
      });
    }
  };

  // Handle file selection change
  const handleFileChange = ({ fileList }) => setFileList(fileList);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);
  useEffect(() => {
    getMessageListHandler();
    const intervalId = setInterval(() => {
      getMessageListHandler();
    }, 10000);
    return () => clearInterval(intervalId);
  }, []);

  const getMessageListHandler = () => {
    getMessageListApi(info.id, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setMessages(res.support);
        } else {
          errorToast(res.message);
        }
      } else {
        console.error(res);
      }
    });
  };

  // Handle clicking the reply icon
  const handleReply = (message) => {
    setReplyingTo(message);
  };

  // Admin-specific function
  const handleReviewProblem = () => {
    let dataInfo = {
      id: info.id,
      status: 1,
    };
    supportStatusApi(dataInfo, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          succToast("عملیات با موفقیت انجام شد!");
          handelCloseModal();
        } else {
          errorToast(res.message);
        }
      } else {
        console.error(res);
      }
    });
  };

  return (
    <div className={styles.chatContainer}>
      {replyingTo && (
        <div className={styles.replyingTo}>
          <p className={styles.ReplyMessage}>در حال پاسخ به: {replyingTo.message}</p>
          <Button
            onClick={() => setReplyingTo(null)}
            style={{ marginLeft: "1rem" }}
          >
            لغو
          </Button>
        </div>
      )}

      <div className={styles.messagesContainer}>
        {messages?.chat?.map((message) => (
          <div
            key={message.id}
            className={
              message.sender === "client"
                ? styles.userMessage
                : styles.receivedMessage
            }
          >
            {message?.reply_to !== 0 ? (
              <div
                className={styles.replyMessageHolder}
                style={{
                  alignSelf:
                    message.sender !== "client" ? "flex-start" : "flex-end",
                }}
              >
                <RollbackOutlined />: {messages?.chat?.filter(item=>item.id===message?.reply_to)[0]?.message}{" "}
              </div>
            ) : null}
            <p className={styles.messageText}>{message.message}</p>
            {message?.files?.length !== 0 ? (
              <p className={styles.linkHolder}>
                <a
                  href={`https://cdn.barest.ir/support/${message?.files[0]}`}
                  download={`https://cdn.barest.ir/support/${message?.files[0]}`}
                  className={styles.fileLink}
                >
                  {`فایل پیوست`} <FileOutlined />
                </a>
              </p>
            ) : null}
            <div className={styles.messageDateStatus}>
              <span className={styles.messageDate}>
                {moment
                  .unix(parseInt(message.date))
                  .format("jYYYY/jM/jD--hh:mm")}
              </span>
              {message.sender !== "client" ? (
                <FontAwesomeIcon
                  icon={message?.status === "0" ? faCheck : faCheckDouble}
                />
              ) : null}
            </div>
            {message.sender === "client" ? (
              <button
                className={styles.replyIconHolder}
                onClick={() => handleReply(message)}
              >
                پاسخ
              </button>
            ) : null}
          </div>
        ))}
        <div ref={bottomRef} />
      </div>
      {messages.status!=="2"?<div className={styles.inputContainer}>
        <Input
          className={styles.inputField}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="متن پیام..."
          onPressEnter={handleSendMessage}
        />
        <Button
          type="primary"
          onClick={handleSendMessage}
          style={{ background: "rgb(187, 0, 134)", border: "none" }}
          loading={loadingState}
          disabled={loadingState}
        >
          <SendOutlined rotate={180}/>
        </Button>
      </div>:<Alert type="error" message=" این گفت و گو خاتمه یافته!" banner style={{direction:'rtl'}}/>}
      {messages.status!=="2"?<div className={styles.inputContainer}>
        <Upload
          beforeUpload={() => false} // Prevent auto upload
          fileList={fileList}
          onChange={handleFileChange}
          showUploadList={false}
          accept=".png,.jpg,.jpeg,.pdf,.docx,.zip"
        >
          <Button icon={<UploadOutlined />} className={styles.uploadButton}>
            آپلود فایل
          </Button>
        </Upload>

        <Button onClick={handleReviewProblem} className={styles.reviewButton}>
          بررسی مشکل
        </Button>
      </div>:null}
    </div>
  );
};

export default AdminSupportChat;
